function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Fragment, useMemo } from 'react';
import { ArrowDown, ArrowUp, ArrowUpDown, Loader2 } from 'lucide-react';
import { TableVirtuoso } from 'react-virtuoso';
import { cn } from '../../lib/utils';
const Table = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className, border = true } = _ref1, props = _object_without_properties(_ref1, [
        "className",
        "border"
    ]), [ref] = _rest;
    return /*#__PURE__*/ _jsx("div", {
        className: cn('relative w-full overflow-auto rounded-lg text-white', border && 'border border-muted '),
        children: /*#__PURE__*/ _jsx("table", _object_spread({
            ref: ref,
            className: cn('w-full caption-bottom text-sm', className)
        }, props))
    });
});
const TableHeader = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className } = _ref1, props = _object_without_properties(_ref1, [
        "className"
    ]), [ref] = _rest;
    return /*#__PURE__*/ _jsx("thead", _object_spread({
        ref: ref,
        className: cn('border-b border-muted bg-[#171717]', className)
    }, props));
});
const TableBody = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className } = _ref1, props = _object_without_properties(_ref1, [
        "className"
    ]), [ref] = _rest;
    return /*#__PURE__*/ _jsx("tbody", _object_spread({
        ref: ref,
        className: cn('', className)
    }, props));
});
const TableFooter = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className } = _ref1, props = _object_without_properties(_ref1, [
        "className"
    ]), [ref] = _rest;
    return /*#__PURE__*/ _jsx("tfoot", _object_spread({
        ref: ref,
        className: cn('border-t bg-muted/50 font-medium [&>tr]:last:border-b-0', className)
    }, props));
});
const TableRow = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className, sx, style } = _ref1, props = _object_without_properties(_ref1, [
        "className",
        "sx",
        "style"
    ]), [ref] = _rest;
    return /*#__PURE__*/ _jsx("tr", _object_spread({
        ref: ref,
        style: _object_spread({}, sx, style),
        className: cn('[&_td]:p-4 [&_td]:text-sm [&_td]:font-medium transition-colors border-b border-muted last:border-b-0', className)
    }, props));
});
const TableHead = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className, align = 'left', width, sx, style, children, sortable = false, sortDirection = 'none', onSortClick, accessory } = _ref1, props = _object_without_properties(_ref1, [
        "className",
        "align",
        "width",
        "sx",
        "style",
        "children",
        "sortable",
        "sortDirection",
        "onSortClick",
        "accessory"
    ]), [ref] = _rest;
    const renderSortIcon = ()=>{
        if (!sortable) {
            return null;
        }
        if (sortDirection === 'asc') {
            return /*#__PURE__*/ _jsx(ArrowUp, {
                size: 16
            });
        }
        if (sortDirection === 'desc') {
            return /*#__PURE__*/ _jsx(ArrowDown, {
                size: 16
            });
        }
        return /*#__PURE__*/ _jsx(ArrowUpDown, {
            size: 16
        });
    };
    return /*#__PURE__*/ _jsx("th", _object_spread_props(_object_spread({
        ref: ref,
        style: _object_spread({
            width
        }, sx, style),
        className: cn('align-middle font-medium py-3 px-4', "text-".concat(align), className)
    }, props), {
        children: /*#__PURE__*/ _jsxs("div", {
            className: cn("flex items-center gap-2", "justify-".concat(align === 'left' ? 'start' : align === 'right' ? 'end' : 'center')),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-[#A3A3A3]",
                    children: children
                }),
                accessory,
                sortable && /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "cursor-pointer text-[#A3A3A3] inline-flex h-6 w-6 items-center justify-center rounded transition hover:text-foreground",
                    onClick: onSortClick,
                    children: renderSortIcon()
                })
            ]
        })
    }));
});
const TableCell = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className, align = 'left', width, sx, style, colSpan } = _ref1, props = _object_without_properties(_ref1, [
        "className",
        "align",
        "width",
        "sx",
        "style",
        "colSpan"
    ]), [ref] = _rest;
    return /*#__PURE__*/ _jsx("td", _object_spread({
        ref: ref,
        colSpan: colSpan,
        style: _object_spread({
            width
        }, sx, style),
        className: cn('py-8 px-6 align-middle', {
            'text-left': align === 'left',
            'text-center': align === 'center',
            'text-right': align === 'right'
        }, className)
    }, props));
});
const TableCaption = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className } = _ref1, props = _object_without_properties(_ref1, [
        "className"
    ]), [ref] = _rest;
    return /*#__PURE__*/ _jsx("caption", _object_spread({
        ref: ref,
        className: cn('mt-4 text-sm text-muted-foreground', className)
    }, props));
});
const defaultVirtuosoComponents = {
    Table: (_0)=>{
        let { style } = _0, props = _object_without_properties(_0, [
            "style"
        ]);
        return /*#__PURE__*/ _jsx("table", _object_spread_props(_object_spread({}, props), {
            className: "w-full caption-bottom text-sm",
            style: _object_spread_props(_object_spread({}, style), {
                borderSpacing: 0,
                tableLayout: 'fixed'
            })
        }));
    },
    TableHead: (props)=>/*#__PURE__*/ _jsx(TableHeader, _object_spread_props(_object_spread({}, props), {
            style: {
                position: 'sticky',
                top: 0,
                zIndex: 2
            }
        })),
    TableRow: (props)=>/*#__PURE__*/ _jsx(TableRow, _object_spread({}, props)),
    TableBody: (props)=>/*#__PURE__*/ _jsx(TableBody, _object_spread({}, props))
};
export function VirtualTable(param) {
    let { loadNextPage, rows, headers, tableComponents, className, height, containerStyle, defaultItemHeight = 80, isLoading = false } = param;
    const headerContent = ()=>{
        return /*#__PURE__*/ _jsx(TableRow, {
            className: "border-b border-secondary",
            children: headers.map((column)=>/*#__PURE__*/ _jsx(TableHead, {
                    align: column.align,
                    width: column.width,
                    className: "text-xs text-secondary-text",
                    sortable: column.sortable,
                    sortDirection: column.sortDirection,
                    onSortClick: column.onSortClick,
                    children: column.label
                }, column.dataKey))
        });
    };
    const rowContent = (_index, row)=>{
        const isLoadingRow = row.__isLoadingRow === true;
        if (isLoadingRow) {
            return /*#__PURE__*/ _jsx(Fragment, {
                children: /*#__PURE__*/ _jsx(TableCell, {
                    colSpan: headers.length,
                    align: "center",
                    className: "py-8",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(Loader2, {
                                className: "h-5 w-5 animate-spin text-muted-foreground"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-sm text-muted-foreground",
                                children: "Loading..."
                            })
                        ]
                    })
                })
            });
        }
        return /*#__PURE__*/ _jsx(Fragment, {
            children: headers.map((column)=>/*#__PURE__*/ _jsx(TableCell, {
                    align: column.align,
                    width: column.width,
                    children: row[column.dataKey]
                }, column.dataKey))
        });
    };
    const computedHeight = typeof height === 'number' ? "".concat(height.toString(), "px") : typeof height === 'string' ? height : undefined;
    const dataWithLoadingRow = useMemo(()=>{
        if (!isLoading) {
            return rows;
        }
        const loadingRow = {
            __isLoadingRow: true
        };
        return [
            ...rows,
            loadingRow
        ];
    }, [
        rows,
        isLoading
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: cn('relative w-full text-white', className),
        style: _object_spread({
            height: computedHeight
        }, containerStyle),
        children: /*#__PURE__*/ _jsx(TableVirtuoso, {
            data: dataWithLoadingRow,
            components: tableComponents !== null && tableComponents !== void 0 ? tableComponents : defaultVirtuosoComponents,
            fixedHeaderContent: headerContent,
            itemContent: rowContent,
            style: {
                height: '100%',
                overflow: 'auto'
            },
            defaultItemHeight: defaultItemHeight,
            endReached: ()=>{
                if (!isLoading) {
                    loadNextPage();
                }
            }
        })
    });
}
export { Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow };
